export default "__VITE_ASSET__Cpqw6xr9__"